import lamp from '@/assets/images/lamp.svg';
import vittaLogo from '@/assets/images/logo-vitta.png';
import { CardInsights } from '@/modules/company/components/buttonInsights/cardInsights';
import { COMPANY_CONFIG } from '@/modules/company/entities/enums/company';
import ICONS from '@/shared/entities/constants/icons';
import useCompany from '@/shared/hooks/useCompany/useCompany';
import { safeJsonParse } from '@/utils/validations/safeJsonParse';
import React from 'react';
import { Grid } from 'vkit/lib/context';

const Insights: React.FC = () => {
  const { getFirstCompanyConfigByKey } = useCompany();

  const healthDataInsight = getFirstCompanyConfigByKey(COMPANY_CONFIG.HEALTH_DATA_INSIGHTS);
  const { link: healthDataInsightLink } = safeJsonParse(healthDataInsight) || {};

  const digitalInsight = getFirstCompanyConfigByKey(COMPANY_CONFIG.DIGITAL_HOSPITAL_INSIGHTS);
  const { link: digitalInsightLink } = safeJsonParse(digitalInsight) || {};

  return healthDataInsightLink || digitalInsightLink ? (
    <Grid gap={32} stretch>
      {
        healthDataInsightLink && (
          <CardInsights
            iconImageUrl={lamp}
            title='Indicadores do Plano de Saúde'
            message='Visualize dados de utilização e acompanhe a saúde da sua empresa com mais clareza'

            buttonLink={healthDataInsightLink}
            buttonLabel='Abrir Dashboard'
            buttonIcon={ICONS.LINK}
            buttonIconDir='right'
            buttonEventName='HEATH_DATA_INSIGHTS_ACCESS'
          />
        )
      }

      {
        digitalInsightLink && (
          <CardInsights
            iconImageUrl={vittaLogo}
            title='Indicadores do Hospital Digital'
            message='Acompanhe a perfomance do serviço e indicadores de saúde'

            buttonLink={digitalInsightLink}
            buttonLabel='Abrir Dashboard'
            buttonIcon={ICONS.LINK}
            buttonIconDir='right'
            buttonEventName='DIGITAL_HOSPITAL_INSIGHTS_ACCESS'

            padding={ healthDataInsightLink ? '28px 20px' : undefined }
          />
        )
      }
    </Grid>
  ) : null;
};

export default Insights;
